'use client';
import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
import { USER_SETTINGS_PREFIX } from '#pplx/frontend/apps/ask/user-settings/storage/constants.js';
import { isNonLatinLocale } from '#pplx/frontend/i18n/isNonLatinLocale.js';
import { useLayoutEffect } from 'react';
import { useIntl } from 'react-intl';
const ANSWER_FONT_STYLE_SETTING = 'answerFontStyle';
const HOMEPAGE_HEADING_FONT_STYLE_SETTING = 'homepageHeadingFontStyle';
export const ANSWER_FONT_STYLE_KEY = `${USER_SETTINGS_PREFIX}${ANSWER_FONT_STYLE_SETTING}`;
export const HOMEPAGE_HEADING_FONT_STYLE_KEY = `${USER_SETTINGS_PREFIX}${HOMEPAGE_HEADING_FONT_STYLE_SETTING}`;
/**
 * Applies the answer font and homepage heading font preferences to `<html>`.
 * The answer font defaults to serif; the homepage heading defaults per platform.
 * Non-Latin locales always use sans for both. Runs as a layout effect because
 * the desktop app has no bootstrap snippet to set these before first paint.
 */
export function useApplyAnswerFontStyle() {
    const intl = useIntl();
    const [answerFontStyle] = useLocalUserSettings(ANSWER_FONT_STYLE_SETTING, undefined);
    const [homepageHeadingFontStyle] = useLocalUserSettings(HOMEPAGE_HEADING_FONT_STYLE_SETTING, undefined);
    useLayoutEffect(() => {
        const { dataset } = document.documentElement;
        const isNonLatin = isNonLatinLocale(intl.locale);
        const answerFont = isNonLatin || answerFontStyle === 'sans-serif' ? 'sans-serif' : 'serif';
        dataset.answerFont = answerFont;
        dataset.homeHeadingFont = isNonLatin
            ? 'sans-serif'
            : resolveHomepageHeadingFont(homepageHeadingFontStyle);
    }, [answerFontStyle, homepageHeadingFontStyle, intl.locale]);
}
/** The desktop app's homepage heading has always been serif; web defaults to sans. */
export function getDefaultHomepageHeadingFont() {
    return import.meta.env.VITE_IS_PERPLEXITY_DESKTOP_BUILD ? 'serif' : 'sans-serif';
}
/** Returns the stored homepage heading font, or the platform default when none is stored. */
export function resolveHomepageHeadingFont(homepageHeadingFontStyle, platformDefault = getDefaultHomepageHeadingFont()) {
    return homepageHeadingFontStyle === 'serif' || homepageHeadingFontStyle === 'sans-serif'
        ? homepageHeadingFontStyle
        : platformDefault;
}
//# sourceMappingURL=answerFontStyle.js.map